import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

function ActivationLoadError({ message, referenceId, backTo, backLabel }) {
  const showDetail = Boolean(referenceId);

  return (
    <SrBox
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding="96px 24px"
    >
      <SrBox
        width="140px"
        height="90px"
        marginBottom="28px"
        backgroundImage="url(/images/denied-x-circle.svg)"
        backgroundPosition="center"
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
      />

      <SrText font="greycliff" fontSize="28px" weight="800">
        We hit a problem loading this.
      </SrText>

      {message && !showDetail && (
        <SrBox marginTop="16px" maxWidth="460px">
          <SrText font="greycliff" fontSize="18px" weight="500" color="grey">
            {message}
          </SrText>
        </SrBox>
      )}

      {message && showDetail && (
        <SrBox
          marginTop="28px"
          width="100%"
          maxWidth="640px"
          padding="18px 22px"
          bgColor="blueDark"
          borderRadius="12px"
        >
          <SrText font="greycliff" fontSize="14px" weight="500" color="white" whiteSpace="prewrap">
            {message}
          </SrText>
        </SrBox>
      )}

      {referenceId && (
        <SrBox marginTop="14px">
          <SrText font="greycliff" fontSize="13px" color="grey">
            {`Reference: ${referenceId}`}
          </SrText>
        </SrBox>
      )}

      <SrBox marginTop="36px">
        <SrLink color="blue300" cursor="pointer" to={backTo}>
          {`← ${backLabel}`}
        </SrLink>
      </SrBox>
    </SrBox>
  );
}

ActivationLoadError.propTypes = {
  message: PropTypes.string,
  referenceId: PropTypes.string,
  backTo: PropTypes.string.isRequired,
  backLabel: PropTypes.string.isRequired,
};

ActivationLoadError.displayName = 'ActivationLoadError';

export default ActivationLoadError;
